import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'glb-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class LoginFormComponent implements OnInit {

  constructor() { }

  model: any = {};
  submitted: boolean = true;

  ngOnInit() {
    this.submitted = true;
  }

  onSubmit() {
    if (this.model.username === "globant" && this.model.password === "globant") {
      this.submitted = true;
      alert("Logged in successfully!!");
    }
    else {
      this.submitted = false;
    }
  }

}
